import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  container: {
    background: theme.white,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 10,
    paddingBottom: 10,
    height: 63,
    verticalAlign: 'middle',
  },
  deactivate: {
    color: theme.textLight,
  },
  icons: {
    paddingLeft: 8,
    paddingRight: 8,
    fontSize: 10,
    cursor: 'pointer',
  },
  jumpButton: {
    paddingLeft: 5,
    paddingRight: 5,
    cursor: 'pointer',
    width: 18,
    height: 18,
    textAlign: 'left',
    fontSize: 12,
    border: '1px solid',
    borderRadius: 4,
    borderColor: 'transparent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  active: {
    background: theme.primary,
    color: theme.white,
  },
  dots: {
    paddingBottom: '0.5em',
  },
}))

const SimplePagination = (props) => {
  const { gridApi, data, className, manual = false, currentPage: manualCurrentPage = 0, totalPages: manualTotalPages = 0, onPageChange } = props
  const classes = useStyles()
  const [internalCurrentPage, setInternalCurrentPage] = useState(0)
  const [internalTotalPages, setInternalTotalPages] = useState(0)

  const currentPage = manual ? manualCurrentPage : internalCurrentPage
  const totalPages = manual ? manualTotalPages : internalTotalPages

  useEffect(() => {
    if (!manual && gridApi) {
      gridApi.addEventListener('paginationChanged', handlePagination)
      setInternalTotalPages(gridApi.paginationGetTotalPages())
      setInternalCurrentPage(gridApi.paginationGetCurrentPage())
      return () => {
        if (gridApi) {
          gridApi.removeEventListener(handlePagination)
        }
      }
    }
  }, [gridApi, data, manual])

  const handlePagination = (event) => {
    if (event.newData) {
      setInternalTotalPages(event.api.paginationGetTotalPages())
    }
    if (event.newPage) {
      setInternalCurrentPage(event.api.paginationGetCurrentPage())
    }
  }

  const onBtNext = () => {
    if (currentPage < totalPages - 1) {
      manual ? onPageChange(currentPage + 1) : gridApi.paginationGoToNextPage()
    }
  }

  const onBtPrevious = () => {
    if (currentPage !== 0) {
      manual ? onPageChange(currentPage - 1) : gridApi.paginationGoToPreviousPage()
    }
  }

  const moveTo = (index) => {
    if (index !== currentPage) {
      manual ? onPageChange(index) : gridApi.paginationGoToPage(index)
    }
  }

  const generateButton = (index, pageCount) => {
    const before = index - 1
    const after = index + 1

    const result = []
    if (before === 1) {
      result.push((<div key='jbs' className={classes.jumpButton} onClick={() => moveTo(0)}>1</div>))
    }
    if (before > 1) {
      result.push((<div key='jbs' className={classes.jumpButton} onClick={() => moveTo(0)}>1</div>))
      result.push((<div key={`jbld${index}`} className={classes.dots}>&hellip;</div>))
    }
    if (before >= 0) {
      result.push(<div key={`jb${before}`} className={classes.jumpButton} onClick={() => moveTo(before)}>{before + 1}</div>)
    }
    // current page
    result.push(<div key={`jb${index}`} className={clsx(classes.jumpButton, index === currentPage ? classes.active : null)} >{index + 1}</div>)
    if (after <= pageCount) {
      result.push(<div key={`jbr${pageCount}`} className={classes.jumpButton} onClick={() => moveTo(after)}>{after + 1}</div>)
    }
    if (after < pageCount - 1) {
      result.push(<div key={`jbrd${index}`} className={classes.dots}>&hellip;</div>)
      result.push((<div key={`jbe${pageCount}`} className={classes.jumpButton} onClick={() => moveTo(pageCount)}>{pageCount + 1}</div>))
    }
    if (after === pageCount - 1) {
      result.push((<div key={`jbe${pageCount}`} className={classes.jumpButton} onClick={() => moveTo(pageCount)}>{pageCount + 1}</div>))
    }
    return result
  }

  if (totalPages <= 1) {
    return (<></>)
  }

  return (
    <div className={className}>
      {/* data-qs-id auf beiden Pfeilen (2026-09-21): Playwrights `testIdAttribute` ist genau
          dieses Attribut, und dieser Baustein trug bisher KEINES — die Pfeile waren nur
          `<div className="icon icon-arrow_right">`, also von aussen nicht ansteuerbar. Damit
          war jede Liste der Anwendung beim Blaettern untestbar, nicht nur „Meine Meldungen".
          Rein additiv: nur Attribute, kein Verhalten, keine Struktur. */}
      <div className={classes.container} data-qs-id='simple-pagination'>
        <div data-qs-id='simple-pagination-previous' className={clsx('icon icon-arrow_left', classes.icons, currentPage === 0 ? classes.deactivate : null)} onClick={onBtPrevious} />
        {generateButton(currentPage, totalPages - 1)}
        <div data-qs-id='simple-pagination-next' className={clsx('icon icon-arrow_right', classes.icons, currentPage === totalPages - 1 ? classes.deactivate : null)} onClick={onBtNext} />
      </div>
    </div>
  )
}

SimplePagination.propTypes = {
  data: PropTypes.array.isRequired,
  customClass: PropTypes.string,
  manual: PropTypes.bool,
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  onPageChange: PropTypes.func,
}

export default SimplePagination
